import type { SVGProps } from 'react'

export const CopyPasteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...props}
  >
    <defs>
      <mask id="copy-cutout" maskUnits="userSpaceOnUse" x="0" y="0" width="20" height="20">
        <rect x="0" y="0" width="20" height="20" fill="white" />
        <rect x="2" y="2" width="12" height="12" rx="3" fill="black" />
      </mask>
    </defs>

    <rect
      x="6"
      y="6"
      width="11"
      height="11"
      rx="2"
      stroke="currentColor"
      strokeWidth="1.1"
      strokeLinejoin="round"
      mask="url(#copy-cutout)"
    />

    <rect x="3" y="3" width="11" height="11" rx="2" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
  </svg>
)
